import { style } from "@vanilla-extract/css";

import type { TypographyVariant } from "../types";
import { typographyDefinition } from "../typography";

export const typography = Object.fromEntries(
  Object.entries(typographyDefinition).map(([name, rules]) => [
    name as TypographyVariant,
    style(rules),
  ]),
) as Record<TypographyVariant, string>;
